const tableMetadata = [
  {
    id: 'transDate',
    renderingField: 'transDateStr',
    width: '10%',
    numeric: false,
    disablePadding: false,
    label: 'Date',
    alignment: 'left',
  },
  {
    id: 'paymentType',
    renderingField: 'paymentTypeStr',
    width: '20%',
    numeric: false,
    disablePadding: false,
    label: 'Payment method',
    alignment: 'left',
  },
  {
    id: 'transcode',
    renderingField: 'transcodeStr',
    width: '20%',
    numeric: false,
    hideInMobile: true,
    disablePadding: false,
    label: 'Description',
    alignment: 'left',
  },
  {
    id: 'amount',
    renderingField: 'amountFld',
    width: '10%',
    numeric: false,
    hideInMobile: false,
    disablePadding: false,
    label: 'Amount',
    alignment: 'left',
  },
  {
    id: 'errorCode',
    renderingField: 'errorCodeStr',
    width: '10%',
    numeric: false,
    hideInMobile: true,
    disablePadding: false,
    label: 'Details',
    alignment: 'left',
  },
];

export default tableMetadata;
